var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LineChart"},[_c('div',{staticClass:"header"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{ref:"echars",staticClass:"content"})])}
var staticRenderFns = []

export { render, staticRenderFns }